const Toggle = ({ isToggle, onToggleChange }) => {
    return (
        <div className=''>
            <label className='relative inline-block w-14 h-7'>
                <input type="checkbox" className="opacity-0 w-0 h-0" value={isToggle} onChange={() => onToggleChange(!isToggle)} />
                <span className={`slider before:content-[''] before:absolute before:w-5 before:rounded-full rounded-3xl before:h-5 before:left-1 before:bottom-1 ${isToggle ? 'before:bg-red-100' : 'before:bg-white'} absolute cursor-pointer top-0 right-0 left-0 bottom-0 ${isToggle ? 'bg-logoRed' : 'bg-lighterGrey'} duration-200 ease-linear before:ease-linear before:duration-200 ${isToggle ? 'before:translate-x-7' : 'before:translate-x-0'}`} />
            </label>
        </div>
    )
}

export default Toggle